<template>
    <section :class="[
        'tw-rounded-2xl tw-p-6 tw-shadow-2xl',
        theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'
    ]">
        <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
            <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-indigo-500/10 tw-text-indigo-400' : 'tw-bg-indigo-50 tw-text-indigo-600'">
                <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
            </div>
            <div>
                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Programa de Curvas</h3>
                <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-medium tw-mt-1">Média atual: <span class="tw-font-bold tw-text-blue-500">{{ programaCurva['media'] }}°C</span></p>
            </div>
        </div>
        
        <div class="tw-flex tw-justify-center tw-p-4 tw-rounded-xl">
            <img src="/images/silos/programa-curvas.jpg" alt="Curvas de Programação" class="sm:tw-max-w-xs md:tw-max-w-sm lg:tw-max-w-md tw-w-auto tw-h-auto tw-rounded-lg">
        </div>
    </section>
</template>
<script>
export default {
    props: {
        parametros: {
            type: Object,
            default: () => ({})
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    computed: {
        programaCurva() {
            if (this.parametros && this.parametros['4']) {
                return this.parametros['4']
            }
            return {
                "media": ""
            }
        },
    }
}
</script>